import React from 'react';
import Page from '../component/page';

@Page.renderToDom()
export default class Home extends Page {
    componentDidMount() {

    }

    render() {
        return (
            <div className="error-page" style={{ textAlign: 'center', fontSize: 14, color: '#666' }}>
                <img src="https://i.gsxcdn.com/1372794244_of7bvqds.svg" alt="页面找不到" style={{ width: 250, height: 150, marginTop: 150 }} />
                <div style={{ marginTop: 18 }}>网页找不到了</div>
            </div>
        );
    }
}
